<template>
  <section
    id="intro"
    class="relative mx-auto max-w-7xl px-6 py-16 md:py-24"
  >
    <div class="grid md:grid-cols-12 gap-10">
      <div class="md:col-span-5">
        <h2
          class="text-3xl md:text-5xl font-semibold tracking-tight text-neutral-900"
        >
          INTRODUCTION
        </h2>
        <p class="mt-6 text-neutral-700 leading-relaxed">
          {{ introductionText }}
        </p>
        <div class="mt-6 flex flex-wrap gap-2">
          <span
            v-for="skill in skillComponents"
            :key="skill.name"
            class="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm ring-1 ring-neutral-200 shadow-sm hover:ring-neutral-300"
          >
            <component :is="skill.icon" :size="16" :class="skill.iconColor" />
            {{ skill.name }}
          </span>
        </div>
      </div>
      <div class="md:col-span-7 relative">
        <div
          class="relative rounded-2xl overflow-hidden ring-1 ring-neutral-200 bg-white shadow-sm w-full"
        >
          <img
            :src="studioImage"
            alt="Studio workspace"
            class="w-full h-auto max-h-[350px] object-contain block"
          />
          <div
            class="absolute inset-0 bg-gradient-to-t from-white/60 to-transparent pointer-events-none"
          ></div>
          <div class="absolute bottom-0 left-0 right-0 p-6">
            <p class="text-neutral-900 font-medium">Muhammad Saad Mehboob</p>
            <p class="text-sm text-neutral-600">
              Designing, UI/UX, Graphics, and Social Media Marketing
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Figma, MousePointer2, LayoutDashboard } from 'lucide-vue-next'

export default {
  name: 'UIUXIntroduction',
  components: {
    Figma,
    MousePointer2,
    LayoutDashboard
  },
  props: {
    introductionText: {
      type: String,
      default: 'I craft thoughtful digital experiences that blend utility, clarity, and emotion. My process orbits research, rapid prototyping, and tasteful visual systems that scale. Below is a concise snapshot of recent work spanning product design, creative direction, and experimental visuals.'
    },
    studioImage: {
      type: String,
      default: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1600&auto=format&fit=crop'
    },
    skills: {
      type: Array,
      default: () => [
        { name: 'Figma', icon: 'Figma', iconColor: 'text-pink-500' },
        { name: 'Prototyping', icon: 'MousePointer2', iconColor: 'text-emerald-600' },
        { name: 'Design Systems', icon: 'LayoutDashboard', iconColor: 'text-sky-600' }
      ]
    }
  },
  computed: {
    skillComponents() {
      const iconMap = {
        Figma,
        MousePointer2,
        LayoutDashboard
      }
      return this.skills.map(skill => ({
        ...skill,
        icon: iconMap[skill.icon] || Figma
      }))
    }
  }
}
</script>

